import { Link } from 'gatsby';
import React from 'react';
import { IPost } from '../lib/post-tools';

interface IProps {
  posts: IPost[];
}

export const PostList = (props: IProps) => {
  const { posts } = props;
  // return <><div>{typeof  posts}</div><div>{JSON.stringify(posts)}</div></>
  if (!posts) {
    return <></>;
  }
  return (
    <>
      <div className="is-size-4">Recent Posts</div>
      <ul>
        {posts.map(post => (
          <li key={post.id}>
            <Link to={post.fields.slug}>
              {post.frontmatter ? post.frontmatter.title : ''}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};
